//
//
//
//
//
//
//
//
//
//
//
//
//
import sourceLong from '../md/long.md';
import sourceShort from '../md/short.md';
export default {
  props: {
    // 指定为长文本
    long: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      sourceLong: sourceLong,
      sourceShort: sourceShort,
      isLong: false
    };
  },
  created: function created() {
    this.isLong = this.long;
  }
};